import { AppLocale } from '@cineamo/api/types/AppLocale';

export enum Locale {
    de_DE = 'de_DE',
    de_AT = 'de_AT',
    de_CH = 'de_CH',
    en_GB = 'en_GB',
    en_US = 'en_US'
}

export const AvailableLocales: Locale[] = Object.values(Locale);

// Both Records force exhaustiveness: adding a member on either side is a compile error here.
const LOCALE_TO_APP_LOCALE: Record<Locale, AppLocale> = {
    [Locale.de_DE]: 'de-DE',
    [Locale.de_AT]: 'de-AT',
    [Locale.de_CH]: 'de-CH',
    [Locale.en_GB]: 'en-GB',
    [Locale.en_US]: 'en-US'
};

const APP_LOCALE_TO_LOCALE: Record<AppLocale, Locale> = {
    'de-DE': Locale.de_DE,
    'de-AT': Locale.de_AT,
    'de-CH': Locale.de_CH,
    'en-GB': Locale.en_GB,
    'en-US': Locale.en_US
};

/** Converts the underscore Locale enum (user preference / backend DTO format) to the hyphenated URL locale. */
export function toAppLocale(locale: Locale): AppLocale {
    return LOCALE_TO_APP_LOCALE[locale];
}

/** Converts a hyphenated URL locale back to the underscore Locale enum. */
export function toLocale(appLocale: AppLocale): Locale {
    return APP_LOCALE_TO_LOCALE[appLocale];
}
